<div class="like-counter-inner">
  <ion-button [class.liked]="likes.isLikedByUser" fill="clear" (click)="onClick()">
    <ion-icon slot="icon-only" [name]="likes.isLikedByUser ? 'heart' : 'heart-outline'"></ion-icon>
  </ion-button>
  <div *ngIf="!hideTotal" class="counter">{{ likes.totalLikes }}</div>
</div>
